<template>
  <div :class="[templateClass]">
    <button
      v-if="showSaveButton"
      :class="[submitButtonClass, saveDisabled ? 'disabled' : '']"
      @click="$emit('saveClicked')"
    >
      {{ saveButtonText }}
    </button>

    <a
      v-if="cancelAsLink && showCancelButton"
      href="#"
      :class="[cancelDisabled ? 'disabled' : '', cancelButtonClass]"
      :disabled="cancelDisabled"
      @click.prevent="cancelClicked"
      >Cancel</a
    >

    <button
      v-if="showCancelButton && !cancelAsLink"
      class="btn btn-outline cancel"
      :class="[cancelDisabled ? 'disabled' : '', cancelButtonClass]"
      @click="$emit('cancelClicked')"
    >
      {{ cancelButtonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CheckoutSectionSave',
  props: {
    templateClass: {
      type: String,
      required: false,
      default: 'columns form-buttons',
    },
    saveDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSaveButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    saveButtonText: {
      type: String,
      required: false,
      default: 'Save & Continue',
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: 'Cancel',
    },
    submitButtonClass: {
      type: String,
      required: false,
      default: '',
    },
    cancelAsLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancelButtonClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['saveClicked', 'cancelClicked'],
  methods: {
    cancelClicked(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$emit('cancelClicked', event)
      return false
    },
  },
}
</script>

<style scoped></style>
